export default "__VITE_ASSET__DM1qmACN__"